<template>
  <div v-if="banners.length" class="gs-section">
    <div class="gs-section__toolbar">
      <p class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div class="gs-asset-grid gs-asset-grid--media">
      <asset-card
        v-for="(banner, index) in banners"
        :key="banner.id || index"
        :title="banner.name"
        :subtitle="dimensions[index]"
      >
        <template slot="preview">
          <div class="gs-asset-image">
            <img
              :src="banner.image"
              :alt="$t('frontend_product_banner_image')"
              @load="captureDimensions(index, $event)"
            />
          </div>
        </template>

        <template slot="default">
          <p class="gs-asset-label">{{ $t('frontend_groovesell_banner_embed_code') }}</p>
          <div class="gs-asset-well">
            <pre class="gs-asset-code gs-banner-embed">{{ banner.embed }}</pre>
          </div>
        </template>

        <template slot="actions">
          <copy-button
            :text="banner.embed"
            label="Copy embed"
            :title="$t('frontend_resource_copy_banner_embed')"
          />
          <a
            class="gs-button gs-button--outline gs-button--sm gs-download"
            :href="banner.image"
            :download="banner.name"
            target="_blank"
            rel="noopener"
            title="Download this banner image"
          >
            <gs-icon name="download" size="15" />
            Download
          </a>
        </template>
      </asset-card>
    </div>
  </div>

  <div v-else class="gs-empty">
    <span class="gs-empty__icon"><gs-icon name="image" size="22" /></span>
    <p class="gs-empty__title">{{ $t('frontend_resource_no_banners') }}</p>
    <p class="gs-empty__text">Banner images and their embed code show up here.</p>
  </div>
</template>

<script>
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    AssetCard,
    CopyButton,
  },
  props: {
    funnelResource: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Real pixel size per banner, read off the image once it has loaded.
      dimensions: {},
    };
  },
  computed: {
    banners() {
      return (this.funnelResource && this.funnelResource.banners) || [];
    },
    countLabel() {
      const count = this.banners.length;
      return `${count} ${count === 1 ? 'banner' : 'banners'}`;
    },
  },
  methods: {
    captureDimensions(index, event) {
      const image = event.target;

      if (!image.naturalWidth) {
        return;
      }

      this.$set(this.dimensions, index, `${image.naturalWidth} × ${image.naturalHeight}`);
    },
  },
};
</script>

<style scoped>
/* The embed stays readable at a glance without pushing the card long; the
   whole thing is one click away on the Copy embed action. */
.gs-banner-embed {
  max-height: 66px;
  overflow-y: auto;
}
</style>
